import {
  Button,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import {
  GetMeAction,
  refreshTokenAction,
  sendOtpForSignUpAction,
} from '../../Onboarding/auth/action';
import { useDispatch, useSelector } from 'react-redux';
import { addUserThroughExistingCompany } from '../APIs/action';
import { toast } from 'react-toastify';
import { getSecondaryPermissionsAction } from '../../../screen/auth/action';

function OwnersDetails({ firmDetails = {}, onRefresh = () => {} }) {
  const dispatch = useDispatch();

  const [isAddingOwner, setIsAddingOwner] = useState(false);
  const [ownerOptions, setOwnerOptions] = useState(
    firmDetails?.proprietors_list || [],
  );

  useEffect(() => {
    setOwnerOptions(firmDetails?.proprietors_list || []);
  }, [firmDetails]);

  const { loginUser } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
    };
  });

  const [isOwner, setIsOwner] = useState(true);
  const [isOwnersPhoneNumber, setIsOwnersPhoneNumber] = useState(true);

  const [ownerObj, setOwnerObj] = useState({
    firstname: '',
    lastname: '',
    phone_number: null,
    otp: null,
  });
  const handleIsOwnerPhoneChange = (_, newAlignment) => {
    if (newAlignment === null) return;
    setIsOwnersPhoneNumber(newAlignment);
  };

  const setUserDetails = async () => {
    const { error, data } = await GetMeAction();

    if (!error) {
      dispatch({ type: 'SET_USER', data });
    }
  };

  const setSecondaryRoles = async () => {
    const { data: secPermissionData, error } =
      await getSecondaryPermissionsAction();

    if (!error) {
      dispatch({
        type: 'SET_SECONDARY_PERMISSION',
        data: secPermissionData,
      });
      dispatch({
        type: 'SET_SECONDARY_PERMISSION_ROLES',
        data: secPermissionData.map((item) => item.role_name),
      });
    }
  };

  const onAddOwner = async () => {
    const payload = {
      phone_number: isOwnersPhoneNumber
        ? loginUser.phone_no
        : ownerObj.phone_number,
      otp: null,
      email: null,
      firstname: ownerObj.firstname,
      lastname: ownerObj.lastname,
      privacy_policy_accept_status: true,
      password: null,
      company_id: firmDetails.company_id,
      is_owner: true,
      permissions: ['COMPANY_ADMIN'],
      is_owner_phone_number: isOwnersPhoneNumber,
    };

    const { error, message } = await addUserThroughExistingCompany(payload);

    if (error) {
      return toast.error(message);
    } else {
      setIsAddingOwner(false);
      setIsOwner(true);
      setOwnerObj({
        firstname: '',
        lastname: '',
        phone_number: null,
        otp: null,
      });

      const params = new URLSearchParams();
      params.append('hard_refresh', true);
      const { data: tokenData, error: tokenError } = await refreshTokenAction(
        params,
      );

      if (tokenData) localStorage.setItem('token', tokenData);

      setSecondaryRoles();
      setUserDetails();
      toast.success('Owner Added Successfully');

      onRefresh();
    }
  };

  return (
    <Card sx={{ mt: '1rem' }}>
      <CardHeader
        title='Add Owners Detail'
        sx={{ backgroundColor: '#f5f5f5' }}
        action={
          <Stack
            direction='row'
            spacing={2}>
            <Tooltip title={isAddingOwner ? 'Cancel' : 'Add Owner'}>
              <IconButton
                color='primary'
                onClick={() => {
                  if (!isAddingOwner) {
                    setIsAddingOwner(true);
                  } else {
                    setIsAddingOwner(false);
                  }
                }}>
                {isAddingOwner ? (
                  <CloseIcon sx={{ color: 'red' }} />
                ) : (
                  <AddIcon />
                )}
              </IconButton>
            </Tooltip>
          </Stack>
        }
      />
      <CardContent>
        {firmDetails?.existing_proprietors_list.length > 0 ? (
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              aria-label='simple table'>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell align='right'>Phone Number</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {firmDetails?.existing_proprietors_list?.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell
                      component='th'
                      scope='row'>
                      {row.firstname} {row.lastname}
                    </TableCell>
                    <TableCell align='right'>{row.phone_number}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : null}

        {isAddingOwner && (
          <>
            <Grid
              container
              sx={{ mb: 2, mt: 2 }}>
              <Grid
                item
                xs={6}
                md={5}
                alignContent='center'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Name
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
                md={7}
                alignContent='center'>
                <FormControl fullWidth>
                  <InputLabel id='demo-simple-select-label'>
                    Select Owner
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    label='Select Owner'
                    onChange={(e) => {
                      const found = ownerOptions.find(
                        (vv) => vv.firstname === e.target.value,
                      );
                      setOwnerObj({
                        ...found,
                      });
                    }}>
                    {ownerOptions.map((item, index) => (
                      <MenuItem
                        value={
                          item.firstname
                        }>{`${item.firstname} ${item.lastname}`}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            {ownerObj.firstname && (
              <>
                <Grid
                  container
                  sx={{ mb: 2 }}>
                  <Grid
                    item
                    xs={6}
                    md={5}
                    alignContent='center'>
                    <Typography
                      variant='h6'
                      fontSize={15}>
                      {`Is ${loginUser.phone_no} ${ownerObj.firstname} ${ownerObj.lastname}'s Phone Number?`}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    md={7}
                    alignContent='center'>
                    <ToggleButtonGroup
                      color='primary'
                      value={isOwnersPhoneNumber}
                      exclusive
                      onChange={handleIsOwnerPhoneChange}
                      aria-label='Platform'>
                      <ToggleButton value={false}>No</ToggleButton>
                      <ToggleButton value={true}>Yes</ToggleButton>
                    </ToggleButtonGroup>
                  </Grid>
                </Grid>

                {/* Phone Number */}
                {isOwner && !isOwnersPhoneNumber && (
                  <>
                    <Grid
                      container
                      sx={{ mb: 2 }}>
                      <Grid
                        item
                        xs={6}
                        md={5}
                        alignContent='center'>
                        <Typography
                          variant='h6'
                          fontSize={15}>
                          Owner Phone Number
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={7}
                        alignContent='center'>
                        <TextField
                          label='Phone Number'
                          name='phone_number'
                          value={ownerObj.phone_number}
                          onChange={(e) => {
                            if (
                              /^\d*$/.test(e.target.value) &&
                              e.target.value.length <= 10
                            )
                              setOwnerObj((prev) => ({
                                ...prev,
                                phone_number: e.target.value,
                              }));
                          }}
                          fullWidth
                          margin='normal'
                        />
                      </Grid>
                    </Grid>
                  </>
                )}

                <Stack
                  direction={'row'}
                  spacing={4}
                  sx={{
                    justifyContent: 'flex-end',
                    marginTop: 2,
                  }}>
                  <Button
                    onClick={onAddOwner}
                    variant='contained'>
                    Add Owner
                  </Button>
                </Stack>
              </>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}

export default OwnersDetails;
